import { Box, Button, Center, Flex, Image, Stack, Text } from '@mantine/core';
import { ScissorsIcon } from '@phosphor-icons/react';
import type { FC } from 'react';

interface ImagePreviewProps {
  previewSrc: string;
  onRecrop: () => void;
}

export const ImagePreview: FC<ImagePreviewProps> = ({ previewSrc, onRecrop }) => {
  return (
    <Center h="100%" p="xl" style={{ flex: 1 }}>
      <Stack align="center" gap="sm">
        <Text c="dimmed" size="xs" style={{ textTransform: 'uppercase', letterSpacing: 1 }}>
          This is how your event will look on gogigi.com
        </Text>

        {/* Event card mockup matching gogigi.com styling */}
        <Box
          bg="white"
          maw={260}
          style={{
            borderRadius: 24,
            overflow: 'hidden',
            boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
            border: '1px solid #e5e7eb',
          }}
        >
          {/* 4:5 portrait image with reserved space */}
          <Box bg="gray.1" style={{ aspectRatio: '4 / 5', width: 260 }}>
            <Image alt="Event artwork preview" h="100%" src={previewSrc} style={{ borderRadius: 24 }} w={260} />
          </Box>
          {/* Card body — skeleton placeholder lines */}
          <Box pb="md" pt="xs" px="md">
            {/* Category badges */}
            <Flex gap={4} mb={8}>
              <Box bg="gray.2" h={18} style={{ borderRadius: 10 }} w={60} />
              <Box bg="gray.2" h={18} style={{ borderRadius: 10 }} w={55} />
            </Flex>
            {/* Title */}
            <Box bg="gray.3" h={12} mb={6} style={{ borderRadius: 4 }} w="75%" />
            {/* Date */}
            <Box bg="gray.2" h={8} mb={4} style={{ borderRadius: 4 }} w="55%" />
            {/* Venue */}
            <Box bg="gray.2" h={8} style={{ borderRadius: 4 }} w="45%" />
          </Box>
        </Box>

        <Text c="dimmed" size="xs">
          Re-crop to adjust
        </Text>
        <Button
          color="gray.5"
          leftSection={<ScissorsIcon size={22} weight="bold" />}
          radius="sm"
          size="sm"
          styles={{ section: { marginRight: 8 } }}
          variant="outline"
          onClick={onRecrop}
        >
          Re-crop
        </Button>
      </Stack>
    </Center>
  );
};
